import React, { useCallback } from 'react';
import cn from 'classnames';
import { IconButton } from '../../icon-button/esm';
import { Link } from '../../link/esm';
import { Spinner } from '../../spinner/esm';
import { CrossMIcon } from '@alfalab/icons-glyph/CrossMIcon';
import { CheckmarkCircleMIcon } from '@alfalab/icons-glyph/CheckmarkCircleMIcon';
import { AlertCircleMIcon } from '@alfalab/icons-glyph/AlertCircleMIcon';
import '@alfalab/icons-glyph';
import { fileIcon, humanFileSize } from './utils.js';

var styles = {"component":"file-upload-item__component_18g4t","info":"file-upload-item__info_18g4t","icon":"file-upload-item__icon_18g4t","errorIcon":"file-upload-item__errorIcon_18g4t","successIcon":"file-upload-item__successIcon_18g4t","name":"file-upload-item__name_18g4t","meta":"file-upload-item__meta_18g4t","size":"file-upload-item__size_18g4t","delete":"file-upload-item__delete_18g4t","error":"file-upload-item__error_18g4t"};
require('./index.css');

var FileUploadItem = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.id, id = _b === void 0 ? '0' : _b, _c = _a.name, name = _c === void 0 ? '' : _c, size = _a.size, uploadDate = _a.uploadDate, downloadLink = _a.downloadLink, uploadStatus = _a.uploadStatus, _d = _a.uploadPercent, uploadPercent = _d === void 0 ? 0 : _d, _e = _a.error, error = _e === void 0 ? uploadStatus === 'ERROR' ? 'Не удалось загрузить файл' : undefined : _e, showDelete = _a.showDelete, showRestore = _a.showRestore, onDelete = _a.onDelete, onDownload = _a.onDownload, onRestore = _a.onRestore, dataTestId = _a.dataTestId;
    var handleDownload = useCallback(function (event) {
        if (onDownload) {
            event.preventDefault();
            onDownload(id);
        }
    }, [id, onDownload]);
    var handleDelete = useCallback(function () {
        if (onDelete)
            onDelete(id);
    }, [id, onDelete]);
    var handleRestore = useCallback(function () {
        if (onRestore)
            onRestore(id);
    }, [id, onRestore]);
    var renderIcon = useCallback(function () {
        switch (uploadStatus) {
            case 'ERROR':
                return React.createElement(AlertCircleMIcon, { className: styles.errorIcon });
            case 'SUCCESS':
                return React.createElement(CheckmarkCircleMIcon, { className: styles.successIcon });
            case 'LOADING':
            case 'UPLOADING':
                return React.createElement(Spinner, { visible: true });
            default: {
                var Icon = fileIcon(name);
                return React.createElement(Icon, { className: styles.icon });
            }
        }
    }, [name, uploadStatus]);
    var renderName = useCallback(function () { return (React.createElement("div", { className: styles.name }, downloadLink ? (React.createElement(Link, { pseudo: true, href: downloadLink, onClick: handleDownload }, name)) : (name))); }, [downloadLink, handleDownload, name]);
    var showMeta = !showRestore && (!uploadStatus || uploadStatus === 'SUCCESS');
    return (React.createElement("div", { className: cn(className, styles.component, uploadStatus && styles[uploadStatus.toLocaleLowerCase()]), "data-test-id": dataTestId },
        React.createElement("div", { className: styles.info },
            renderIcon(),
            renderName(),
            children,
            uploadStatus === 'UPLOADING' && React.createElement("span", null, Math.round(uploadPercent) + "%"),
            uploadStatus === 'ERROR' && React.createElement("span", { className: styles.error }, error),
            showMeta && (React.createElement("div", { className: styles.meta },
                uploadDate && React.createElement("span", { key: uploadDate }, uploadDate),
                size && (React.createElement("span", { key: size, className: styles.size }, humanFileSize(size)))))),
        showRestore && (React.createElement(Link, { pseudo: true, className: styles.restore, onClick: handleRestore }, "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C")),
        showDelete && !showRestore && (React.createElement(IconButton, { size: 'xxs', icon: CrossMIcon, onClick: handleDelete, className: styles.delete, "aria-label": '\u0443\u0434\u0430\u043B\u0438\u0442\u044C' }))));
};

export { FileUploadItem };
